import React from "react";
import Lottie from "lottie-react";
import animationData from "../../animation/loading.json";

const Loading = () => {
  return (
    <div className="loading">
      <Lottie
              animationData={animationData}
              loop={true}
              autoplay={true}
              style={{ height: 250 }}
            />
    </div>
  );
};

export default Loading;
